import { render } from "./MatrizesView.vue?vue&type=template&id=1a38aebf"
import script from "./MatrizesView.vue?vue&type=script&lang=js"
export * from "./MatrizesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/salvando-arvores-front/salvando-arvores-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__